import { render, staticRenderFns } from "./DescriptiveTagForm.vue?vue&type=template&id=d3b4aa44&"
import script from "./DescriptiveTagForm.vue?vue&type=script&lang=js&"
export * from "./DescriptiveTagForm.vue?vue&type=script&lang=js&"
import style0 from "./DescriptiveTagForm.vue?vue&type=style&index=0&id=d3b4aa44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports